export const gamePlans = {
  _root: "/game-plans",
  create: {
    _root: "/create",
    general: "/general",
    tracking: "/tracking",
    tasks: "/tasks",
    summary: "/summary"
  },
  gamePlan: {
    _root: "/:gamePlanID",
    edit: {
      _root: "/edit",
      general: "/general",
      tracking: "/tracking",
      tasks: "/tasks",
      summary: "/summary"
    }
  }
};
